import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const TabsMeta: ComponentMeta = {
  componentName: "Tabs",
  package: "@mijadesign/web",
  title: "标签页",
  description: "选项卡切换组件，用于在多个内容块之间切换",
  category: ComponentCategory.NAVIGATION,
  icon: "AppstoreOutlined",
  canHaveChildren: true,
  acceptedChildren: ["Tabs.TabPane"],
  props: [
    {
      name: "type",
      label: "标签类型",
      type: PropType.ENUM,
      defaultValue: "line",
      options: [
        { label: "线型", value: "line" },
        { label: "卡片", value: "card" },
        { label: "编辑卡片", value: "editable-card" },
      ],
      group: "展示",
    },
    {
      name: "tabPosition",
      label: "标签位置",
      type: PropType.ENUM,
      defaultValue: "top",
      options: [
        { label: "顶部", value: "top" },
        { label: "右侧", value: "right" },
        { label: "底部", value: "bottom" },
        { label: "左侧", value: "left" },
      ],
      group: "布局",
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "middle",
      options: [
        { label: "大", value: "large" },
        { label: "中", value: "middle" },
        { label: "小", value: "small" },
      ],
      group: "展示",
    },
    {
      name: "activeKey",
      label: "当前激活 key",
      type: PropType.STRING,
      group: "状态",
    },
    {
      name: "defaultActiveKey",
      label: "默认激活 key",
      type: PropType.STRING,
      group: "状态",
    },
    {
      name: "hideAdd",
      label: "隐藏新增按钮",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "type",
      label: "可编辑",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
  ],
  defaultProps: {
    type: "line",
    tabPosition: "top",
    size: "middle",
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Tabs",
  },
  snippet: {
    componentName: "Tabs",
    package: "@mijadesign/web",
    props: { type: "line" },
  },
};

export const TabPaneMeta: ComponentMeta = {
  componentName: "Tabs.TabPane",
  package: "antd",
  title: "标签页签",
  description: "标签页的子组件，定义单个标签页的内容",
  category: ComponentCategory.NAVIGATION,
  icon: "FileOutlined",
  canHaveChildren: true,
  props: [
    {
      name: "key",
      label: "唯一标识",
      type: PropType.STRING,
      required: true,
      group: "基础",
    },
    {
      name: "tab",
      label: "标签标题",
      type: PropType.STRING,
      defaultValue: "标签页",
      group: "内容",
    },
    {
      name: "forceRender",
      label: "强制渲染",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "closable",
      label: "可关闭",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
  ],
  defaultProps: {
    tab: "标签页",
  },
  npm: {
    package: "antd",
    exportName: "Tabs",
  },
  snippet: {
    componentName: "Tabs.TabPane",
    package: "antd",
    props: { tab: "标签页", key: "1" },
  },
};
